module.exports = __webpack_public_path__ + "img/HLF.d15e1b12.jpg";